teacup = require 'teacup'

scopes = null
registeredPartials = null

# _.result, but adams doesn't
# want to depend on underscore.
force = (valOrFunction) ->
  if typeof valOrFunction == 'function'
    valOrFunction()
  else
    valOrFunction

# Returns an object of { val: answer } if
# the keyPath resolves; returns an empty
# object otherwise.
lookupScope = (keyPath, scope) ->
  if keyPath == '.'
    return { val: scope }

  # This can happen within the body of a loop
  if typeof scope != 'object' || scope == null
    return {}

  target = scope
  for key in keyPath.split('.')
    if key not of target
      return {}
    target = target[key]

  val: target

methods =
  mustacheRender: (body, data, partials = {}) ->
    if scopes?
      throw new Error "Cannot nest calls to mustacheRender"
    teacup.render ->
      registeredPartials = partials
      scopes = [data]
      try
        body()
      finally
        scopes = null
        registeredPartials = null
      return

  mustacheVar: (name) ->
    if !scopes?
      throw new Error "Attempt to render a mustache template outside of a mustacheRender"
    for scope in scopes by -1
      result = lookupScope(name, scope)
      if result.hasOwnProperty('val')
        return force(result.val)
    return ''

  mustachePartial: (partialName) ->
    if !registeredPartials?
      throw new Error "Attempt to render a mustache template outside of a mustacheRender"
    if partialName not of registeredPartials
      throw new Error "Unregistered partial #{partialName}"
    registeredPartials[partialName]()

  mustacheBlock: (varName, body) ->
    value = @mustacheVar(varName)

    if !value
      return ''

    returnValue = undefined
    if Array.isArray(value)
      for obj in value
        scopes.push obj
        body()
        scopes.pop()
    else if typeof value == 'object'
      scopes.push value
      returnValue = body()
      scopes.pop()
    else
      returnValue = body()
    return returnValue

  mustacheBlockInverted: (varName, body) ->
    value = @mustacheVar(varName)

    if value
      return ''
    return body()

module.exports = require('proto-extend')(teacup, methods)



// WEBPACK FOOTER //
// ./app/scripts/lib/adams.coffee